/**
 * Termination request-related models
 */

/**
 * Termination request DTO (Response)
 */
export interface TerminationRequestDto {
  id: string;
  leaseId: string;
  requestedDate: string;
  effectiveDate: string;
  reason?: string | null;
  status?: string | null;
  decisionBy?: string | null;
  decisionDate?: string | null;
  refundAmount?: number | null;
  refundDate?: string | null;
  createdAt: string;
  updatedAt: string;
}

/**
 * Request termination request
 */
export interface RequestTerminationRequest {
  leaseId: string;
  effectiveDate: string;
  reason?: string | null;
}

